var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-chart"},[_c('canvas',{ref:"chartCanvas"}),(_vm.percent.length > 0)?_c('div',{staticClass:"percent"},[_vm._v(_vm._s(_vm.percent)+"%")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }